module.exports = __webpack_public_path__ + "static/media/dp.0f7a642e.png";